import useBetaFeatures from "hooks/useBetaFeatures";
import useUser from "hooks/useUser";

/**
 * "Base Layer Refactor" (EVA-35): true → base well layer served by
 * eva-map-svc vector/raster tiles; false → legacy GeoServer WMS raster.
 * Opt-in beta feature: the org must carry the name in `betaFeatures`,
 * unset means legacy.
 * `undefined` until the org (and so its betaFeatures) has loaded, so
 * neither architecture runs on a guess.
 */
export function useBaseLayerRefactor(): Maybe<boolean> {
  const { user } = useUser();
  const { hasFeature } = useBetaFeatures();
  if (!user?.organization) return undefined;
  return hasFeature("Base Layer Refactor");
}
